<template>
  <div class="UserHome pt7" v-title data-title="添加用户">
    <div class="row align-items-center justify-content-around stock-btn">
      <van-button v-for="st in stockBtns" :key="st.name" type="info" @click="go(st.path)">{{st.name}}</van-button>
    </div>
    <div><van-button type="info" plain @click="back" style="width: 60%;">返 回</van-button></div>
  </div>
</template>

<script>
import Vue from 'vue';
import storage from '../../uitls/cacheUtil';

export default Vue.extend({
  name: 'UserHome',
  components: {},
  data() {
    return {
      stockBtns: [
        { name: '合作单位', path: '/user/edit/hzdw' },
        { name: '报价商', path: '/user/edit/bjs' },
      ],
    };
  },
  methods: {
    go(path) {
      if (!path) {
        return;
      }
      storage.local.set('busername', '');
      this.$router.push(path);
    },
    back() {
      this.$router.push('/home');
    },
  },
  created() {
  },
});
</script>
<style scoped>
.UserHome {
  min-height: 100vh;
}
.stock-btn {
  height: 60vh;
  padding: 20px;
}
</style>
